export enum TaskType {
  NEW_CUSTOMER = "New Customer",
  NEW_PROPERTY = "New Property",
  REMOVE_PROPERTY = "Remove Property",
  UPDATE_HOLIDAYS = "Update Holidays",
  UPDATE_INTEREST_RATE = "Update Interest Rate",
  INACTIVATE_RENTAL_PROPERTY = "Deactivate",
  FIELD_VISIT = "Field Visit",
  SUSPECTED_RENTAL = "Suspected Rental",
}

export const TaskTypeMap = new Map<TaskType, string>([
  [TaskType.NEW_CUSTOMER, "New Customer"],
  [TaskType.NEW_PROPERTY, "New Property"],
  [TaskType.REMOVE_PROPERTY, "Remove Property"],
  [TaskType.UPDATE_HOLIDAYS, "Update Holidays"],
  [TaskType.UPDATE_INTEREST_RATE, "Update Interest Rate"],
  [TaskType.INACTIVATE_RENTAL_PROPERTY, "Inactivate property"],
  [TaskType.FIELD_VISIT, "Field Visit"],
  [TaskType.SUSPECTED_RENTAL, "Suspected Rental"],
]);

export const TaskTypeStrMap = new Map<string, TaskType>([
  ["NEW_CUSTOMER", TaskType.NEW_CUSTOMER],
  ["NEW_PROPERTY", TaskType.NEW_PROPERTY],
  ["REMOVE_PROPERTY", TaskType.REMOVE_PROPERTY],
  ["UPDATE_HOLIDAYS", TaskType.UPDATE_HOLIDAYS],
  ["UPDATE_INTEREST_RATE", TaskType.UPDATE_INTEREST_RATE],
  ["DEACTIVATE_RENTAL_PROPERTY", TaskType.INACTIVATE_RENTAL_PROPERTY],
  ["FIELD_VISIT", TaskType.FIELD_VISIT],
  ["SUSPECTED_RENTAL", TaskType.SUSPECTED_RENTAL],
]);

export const TaskTypeIntMap = new Map<number, TaskType>([
  [1, TaskType.NEW_CUSTOMER],
  [2, TaskType.NEW_PROPERTY],
  [3, TaskType.REMOVE_PROPERTY],
  [4, TaskType.UPDATE_HOLIDAYS],
  [5, TaskType.UPDATE_INTEREST_RATE],
  [6, TaskType.INACTIVATE_RENTAL_PROPERTY],
  [7, TaskType.FIELD_VISIT],
  [8, TaskType.SUSPECTED_RENTAL],
]);
